const CheckSession = (loginResult) => {
    if(loginResult === undefined || loginResult.success === false){
        window.location.href = "/";
        return;
    }
}

export default CheckSession;